// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownMenu_root__urg0h","active":"DropdownMenu_active__bvIx1"};